'use client';

import { useEffect } from 'react';

type FocusableElement = HTMLTextAreaElement | HTMLInputElement | HTMLButtonElement | HTMLDivElement;

export const useFocus = (element: FocusableElement | null) => {
  useEffect(() => {
    element?.focus();
  }, [element]);

  return element;
};
